var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWbtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0V2H20V4H22V6H24V18H22V20H20V22H18V24H6V22H4V20H2V18H0V6H2V4H4V2H6V0H18Z",
    fill: "#2775CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0V2H20V4H22V6H24V18H22V20H20V22H18V24H6V22H4V20H2V18H0V6H2V4H4V2H6V0H18Z",
    fill: "#F4F4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92857 5.99996V6.87496H2.21429V7.74996H1.5V16.25H2.21429V17.125H2.92857V18H4.35714V16.25H3.64286V15.375H2.92857V8.62496H3.64286V7.74996H4.35714V5.99996H2.92857Z",
    fill: "#5A5564"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0714 5.99996V6.87496H21.7857V7.74996H22.5V16.25H21.7857V17.125H21.0714V18H19.6428V16.25H20.3571V15.375H21.0714V8.62496H20.3571V7.74996H19.6428V5.99996H21.0714Z",
    fill: "#5A5564"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.92851H6.875V2.21422H7.75V1.49994H16.25V2.21422H17.125V2.92851H18V4.35708H16.25V3.6428H15.375V2.92851H8.625V3.6428H7.75V4.35708H6V2.92851Z",
    fill: "#5A5564"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21.0714H6.875V21.7857H7.75V22.5H16.25V21.7857H17.125V21.0714H18V19.6428H16.25V20.3571H15.375V21.0714H8.625V20.3571H7.75V19.6428H6V21.0714Z",
    fill: "#5A5564"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.498 7.49996H13.1016V5.49996H14.1025V7.49996H15.502V8.49996H16.502V11.5009H15.502V12.5029H16.502V15.5058H15.501V16.5058H14.1025V18.5H13.1016V16.5058H11.498V18.5H10.4971V16.5058H9.49805V16.5H7.49805V15.5H9.49707V8.49996H7.49805V7.49996H10.4971V5.49996H11.498V7.49996ZM11.499 15.5058H13.499V14.5048H14.5V13.5039H13.5V12.5029H11.499V15.5058ZM13.501 10.5019V11.5019H11.5042L11.498 8.50094H13.501V9.50094H14.501V10.5019H13.501Z",
    fill: "#F09242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbtc);
export default __webpack_public_path__ + "static/media/WBTC.eaf1fc60923937518f9d1cfcfce26eeb.svg";
export { ForwardRef as ReactComponent };